import React from 'react';

const LocationPicker = ({ ...props }) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fillRule="evenodd" d="M30.5 17.5h-2.099c-.685 5.694-5.208 10.216-10.901 10.901V30.5a1.5 1.5 0 11-3 0v-2.099C8.807 27.716 4.284 23.194 3.599 17.5H1.5a1.5 1.5 0 110-3h2.099C4.284 8.806 8.807 4.284 14.5 3.599V1.5a1.5 1.5 0 113 0v2.099c5.693.685 10.216 5.207 10.901 10.901H30.5a1.5 1.5 0 110 3m-5-1.5c0-5.238-4.262-9.5-9.5-9.5S6.5 10.762 6.5 16s4.262 9.5 9.5 9.5 9.5-4.262 9.5-9.5m-3 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0"></path></svg>
  )
}

export default LocationPicker
